import { useSelector } from 'react-redux';

import {
  getNotificationsState,
  getNotifications,
} from 'modules/notifications/notificationsSelectors';
import {
  isNotificationOpen,
  getNotificationHeight,
} from 'modules/notifications/notificationsHelpers';

import NotificationToast from 'components/NotificationToast/NotificationToast';

export default props => {
  const notificationsState = useSelector(getNotificationsState);
  const notifications = useSelector(getNotifications);

  let openOffset = 24;

  return (
    <>
      {notifications
        .slice(0)
        .reverse()
        .map(notificationData => {
          const { id } = notificationData;
          const open = isNotificationOpen(notificationsState, id);
          const offset = openOffset;

          if (open) {
            openOffset += getNotificationHeight(notificationData);
          }

          return (
            <NotificationToast
              key={id}
              notificationData={notificationData}
              open={open}
              offset={offset}
            />
          );
        })}
    </>
  );
};
